export default "__VITE_ASSET__CdqML3CM__"